import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {fetchCurrentUserDetailRequest} from '../../actions/user.actions';

const stateToProps = state => {
  return {
    user: state.user,
  };
};

class LoginCheck extends Component {
  componentDidMount() {
    if ((!this.props.user || Object.keys(this.props.user).length === 0) && sessionStorage.getItem('token')) {
      this.props.dispatch(fetchCurrentUserDetailRequest());
    }
  }

  render() {
    if (!sessionStorage.getItem('token')) {
      alert('로그인이 필요한 페이지입니다.\n홈으로 이동합니다.');
      return <Redirect to="/" />;
    }

    if (!this.props.user || Object.keys(this.props.user).length === 0) {
      return <div></div>;
    }

    const {origin} = this.props.location.state || {origin: {pathname: '/'}};
    return <Redirect to={origin} />;
  }
}

export default connect(stateToProps)(LoginCheck);
